<template>
  <div>
<!--    <label for="birthday">{{ initialLabel }} {{ initialIndex + 1  }}: </label>-->
    <input class="form-control" type="date" id="birthday" :min="initialMinDate" :max="initialMaxDate" @input="updateBirthdates" v-model="selectedDate" value="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedDate: this.initialValue,
    };
  },
  props: {
    initialMinDate: String,
    initialMaxDate: String,
    initialLabel: String,
    initialType: String,
    initialValue: String,
    initialIndex: Number,
  },
  created(){
    this.updateBirthdates();
  },
  methods: {
    updateBirthdates() {
      this.$emit("birthdate-updated", {
        index: this.initialIndex,
        birthdate: this.selectedDate,
        type: this.initialType
      });
    }
  },
};
</script>

<style scoped>
.form-control {
  font-size: 14px;
  width: 90%;
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  margin-top: 10px;
}
</style>
